export enum AgentFields {
    ID_ON_TEL_SYS = 'IDOnTelSys',
    TELSYS_USERNAME = 'TelSysUsername',
    OVERRIDE_MONITORING = 'OverrideMonitoring'
}
